<!--  -->
<template>
  <div class="container">
    <div class="home">
      <div class="top-box">
        <div class="flexrbc">
          <div class="flexr0c">
            <div class="title-label"></div>
            <div class="title">账户安全</div>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="safe-level flexr0c">
          <div class="label">您的账户安全等级为</div>
          <div class="strength flex-around-center">
            <div class="item" :class="passStrongType >= 1 ? 'strongActive' : ''">
              弱
            </div>
            <div class="item" :class="passStrongType >= 2 ? 'strongActive' : ''">
              中
            </div>
            <div class="item" :class="passStrongType >= 3 ? 'strongActive' : ''">
              强
            </div>
          </div>
        </div>
        <div class="password flexrbc">
          <div class="flexr0c">
            <img src="../../assets/imgs/register/finshed.png" alt="">
            <div class="flexc0s">
              <div class="title">登录密码</div>
              <div class="subtitle">安全性高的密码可以使账户更安全</div>
            </div>
          </div>
          <div class="change" @click="modify">修改</div>
        </div>
        <div class="password flexrbc">
          <div class="flexr0c">
            <img src="../../assets/imgs/register/finshed.png" alt="">
            <div class="flexc0s">
              <div class="title">绑定手机</div>
              <div class="subtitle">您绑定的手机号为{{phone}}</div>
            </div>
          </div>
          <div class="nochange">暂不支持修改</div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="model1||model2">
      <div v-if="model1" class="pop-box">
        <div class="top flexrcc">
          <div class="title">修改密码</div>
          <img @click="model1=false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexccc">
          <div class="form">
            <div class="flexc0s">
              <div class="label label1">原密码</div>
              <Input v-model="oldPass" type="password" :maxlength="16" placeholder="请输入原密码"></Input>
            </div>
            <div class="flexc0s">
              <div class="label">新密码</div>
              <Input v-model="newPass" type="password" :maxlength="16" placeholder="请输入新密码" @input="passStrong"></Input>
              <div class="strength flex-around-center password-strength">
                <div class="item" :class="passStrongType2 >= 1 ? 'strongActive' : ''">
                  弱
                </div>
                <div class="item" :class="passStrongType2 >= 2 ? 'strongActive' : ''">
                  中
                </div>
                <div class="item" :class="passStrongType2 >= 3 ? 'strongActive' : ''">
                  强
                </div>
              </div>
            </div>
            <div class="flexc0s">
              <div class="label">确认密码</div>
              <Input v-model="comfirmPass" type="password" :maxlength="16" placeholder="请再次输入新密码"></Input>
            </div>
          </div>
        </div>
        <div class="bottom flexccc">
          <div class="save" @click="save">确定</div>
        </div>
      </div>
      <div v-if="model2" class="pop-box2">
        <div class="top flexrcc">
          <div class="title">修改密码</div>
          <img @click="model2=false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content flexrcc">
          <img src="../../assets/imgs/register/success.png" alt="">
          <div class="txt">密码修改成功</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "accountSafe",
  components: {},
  data () {
    return {
      passStrongType: 1,
      passStrongType2: 0,
      model1: false,
      model2: false,
      phone: "",
      oldPass: "",
      newPass: "",
      comfirmPass: "",
    };
  },
  methods: {
    modify () {
      this.oldPass = "";
      this.newPass = "";
      this.comfirmPass = "";
      this.model1 = true;
    },
    passStrong () {
      function checkStrong (val) {
        var modes = 0;
        if (val.length <= 0) return -1;
        if (val.length < 6) return 0;
        if (/\d/.test(val)) modes++; //数字
        if (/[a-z]/.test(val)) modes++; //小写
        if (/[A-Z]/.test(val)) modes++; //大写
        if (/\W/.test(val)) modes++; //特殊字符
        if (val.length > 12) modes++;
        if (modes > 3) return 3;
        return modes;
      }
      let hh = checkStrong(this.newPass);
      this.passStrongType2 = hh;
    },
    save () {
      if (this.oldPass == "") {
        this.$Message['error']({
          background: true,
          content: "请输入原密码"
        });
        return;
      }
      if (this.newPass == "") {
        this.$Message['error']({
          background: true,
          content: "请输入新密码"
        });
        return;
      }
      if (this.comfirmPass == "") {
        this.$Message['error']({
          background: true,
          content: "请再次输入新密码"
        });
        return;
      }
      if (this.newPass.length < 6) {
        this.$Message['error']({
          background: true,
          content: "密码至少六位"
        });
        return;
      }
      if (this.comfirmPass != this.newPass) {
        this.$Message['error']({
          background: true,
          content: "两次输入密码不一致"
        });
        return;
      }
      var session = JSON.parse(localStorage["session"]);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: "aZJJ8ZkfmXRDB9QnM2EI3mK0b6bLrCth",
        oldPassWord: this.oldPass,
        newPassWord: this.newPass,
        pwdLevel: this.passStrongType2
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.model1 = false;
          this.model2 = true;
          this.passStrongType = this.passStrongType2;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
  },
  created () {
    this.phone = JSON.parse(localStorage["session"]).userPhone;

    this.passStrongType = JSON.parse(localStorage["session"]).pwdLevel;
    if (!this.passStrongType) this.passStrongType = 1;
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #fff;

  .home {
    .top-box {
      background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
      border-radius: 10px 10px 0 0;
      width: 100%;
      height: 40px;

      /deep/.ivu-input-with-suffix {
        border-radius: 15px;
      }

      & > div {
        height: 100%;
        width: 928px;
        margin: 0 auto;
      }

      .title-label {
        width: 4px;
        height: 14px;
        background: #2c59c3;
      }

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #2c59c3;
        letter-spacing: 0.4px;
        margin-left: 6px;
      }

      .addOrg {
        width: 80px;
        height: 30px;
        background-image: linear-gradient(180deg, #f5515f 0%, #9f041b 100%);
        border: 1px solid #d0021b;
        border-radius: 6px;
        cursor: pointer;
        margin-left: 30px;

        &:hover {
          background-image: linear-gradient(180deg, #ff7d89 0%, #b4051f 100%);
          border: 1px solid #af1228;
        }

        img {
          width: 14px;
          height: 14px;
          margin-right: 5px;
        }

        .btn {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0.35px;
        }
      }
    }

    .content {
      background: #fff;
      min-height: 775px;
      width: 100%;
      // box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.10);
      border-radius: 0 0 10px 10px;
      box-sizing: border-box;
      padding: 0 26px;

      .safe-level {
        height: 79px;
        border-bottom: 1px dashed rgba(151, 151, 151, 0.2);

        .label {
          margin-right: 12px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #8b93a7;
          letter-spacing: 0.25px;
        }
      }

      .password {
        height: 118px;
        border-bottom: 1px dashed rgba(151, 151, 151, 0.2);

        img {
          width: 20px;
          height: 20px;
          margin-bottom: 25px;
          margin-right: 12px;
        }

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #4a4a4a;
          letter-spacing: 0.29px;
        }

        .subtitle {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #9b9b9b;
          letter-spacing: 0.25px;
          margin-top: 10px;
        }

        .change {
          cursor: pointer;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #2c59c3;
          letter-spacing: 0.25px;
        }

        .nochange {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #d0d4dc;
          letter-spacing: 0.25px;
        }
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop-box {
      width: 480px;
      height: 440px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 344px;
        background-color: #ffffff;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #4a4a4a;
        letter-spacing: 0;

        .label {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #9097a9;
          letter-spacing: 0.3px;
          margin: 14px 0 8px 0;
        }

        .label1 {
          margin-top: 0 !important;
        }

        .password-strength {
          margin-top: 8px;
        }
      }

      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }

      input,
      /deep/.ivu-input {
        width: 368px;
        height: 48px;
        // background: #F5F7FA;
        border-radius: 8px;
        padding-left: 24px;
        font-size: 16px;
        letter-spacing: 0.3px;
      }
    }

    .pop-box2 {
      width: 480px;
      height: 412px;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 366px;
        background-color: #ffffff;
        border-radius: 0 0 10px 10px;

        img {
          width: 60px;
          height: 60px;
          margin-right: 18px;
        }

        .txt {
          font-family: PingFangSC-Medium;
          font-size: 24px;
          color: #4a4a4a;
          letter-spacing: 0.45px;
        }
      }
    }
  }

  .strength {
    width: 230px;
    height: 18px;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    box-shadow: inset 0 0 3px 0 rgba(0, 0, 0, 0.17);
    border-radius: 8px;
    margin-bottom: 8px;

    .strongActive {
      background-image: linear-gradient(
        180deg,
        #fad961 0%,
        #f76b1c 100%
      ) !important;
    }

    .item {
      width: 74px;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #ffffff;
      letter-spacing: 0.22px;
      background-image: linear-gradient(0deg, #c6cfd6 0%, #f5f6f8 100%);
    }

    .item:first-child {
      border-radius: 8px 0 0 8px;
    }

    .item:last-child {
      border-radius: 0 8px 8px 0;
    }

    /* 强度激活样式 */
    .item.active {
      background-image: linear-gradient(180deg, #fad961 0%, #f76b1c 100%);
    }
  }
}
</style>
